export default "__VITE_ASSET__ZG932UZF__"